import script from "./_v-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./_v-modal.vue?vue&type=script&setup=true&lang=js"

import "./_v-modal.vue?vue&type=style&index=0&id=711aee96&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711aee96"]])

export default __exports__